import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { SimulationProvider } from './context/SimulationContext.jsx'
import { AuthProvider } from './context/AuthContext.jsx'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AuthProvider>
      <SimulationProvider>
        <App />
      </SimulationProvider>
    </AuthProvider>
  </React.StrictMode>
)
